export default __webpack_public_path__ + "static/blister-hair-vitality-8d5b6006d7321e6123d4e6949621a518.webp";